// (function () {
//     'use strict';

//     angular.module("imApp").factory("p2TableEditService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 25,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 26,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
